<template>
    <div
        :class="['info-box is-shown push-down', arrowClass, infoBoxClass]"
        :data-test="name"
    >
        <span v-html="text" />
        <slot />
    </div>
</template>

<script>
export default {
    name: 'InfoBox',
    props: {
        arrowAlign: {
            type: String,
            default: null
        },
        arrowShow: {
            type: Boolean,
            default: true
        },
        text: {
            type: String,
            default: ''
        },
        infoBoxClass: {
            type: String,
            default: null
        },
        name: {
            type: String,
            default: null
        }
    },
    computed: {
        arrowClass() {
            if (this.arrowShow && this.arrowAlign === null) {
                return '';
            }

            if (!this.arrowShow) {
                return 'info-box-no-arrow';
            }

            return 'info-box-align-' + this.arrowAlign;
        }
    }
};
</script>
